import _taggedTemplateLiteral from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _defineProperty from "/runner/_work/developers/developers/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _borderRadius, _templateObject;
var _ = function _(t) {
    return t;
  },
  _t;
import mediaqueries from "../../util/mediaqueries";
import styled from 'styled-components';
import { CornersStyle } from "./types";
var borderRadius = (_borderRadius = {}, _defineProperty(_borderRadius, CornersStyle.Default, function () {
  return '0';
}), _defineProperty(_borderRadius, CornersStyle.RoundTop, function (radius) {
  return "".concat(radius, " ").concat(radius, " 0 0");
}), _defineProperty(_borderRadius, CornersStyle.RoundBottom, function (radius) {
  return "0 0 ".concat(radius, " ").concat(radius);
}), _defineProperty(_borderRadius, CornersStyle.RoundAll, function (radius) {
  return radius;
}), _borderRadius);
export var Section = styled.section.withConfig({
  componentId: "sc-jkqyng-0"
})(["background-color:", ";color:", ";border-radius:", ";overflow:hidden;", ""], function (_ref) {
  var backgroundColor = _ref.backgroundColor;
  return backgroundColor;
}, function (_ref2) {
  var textColor = _ref2.textColor;
  return textColor;
}, function (_ref3) {
  var cornersStyle = _ref3.cornersStyle;
  return borderRadius[cornersStyle]('64px');
}, mediaqueries.md(_t || (_t = _(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border-radius: ", ";\n  "])), 0)), function (_ref4) {
  var cornersStyle = _ref4.cornersStyle;
  return borderRadius[cornersStyle]('96px');
}));